export const REQUEST_ENDPROJECT = 'REQUEST_ENDPROJECT';
export const ENDPROJECT_RECEIVED = 'ENDPROJECT_RECEIVED';